import React from "react";

function PolicyPage() {
  return (
    <div style={{
      maxWidth: "800px",
      margin: "0 auto",
      padding: "40px 20px",
      fontFamily: "Arial, sans-serif",
      lineHeight: "1.8",
      color: "#333"
    }}>
      <h1 style={{ textAlign: "center", marginBottom: "40px" }}>개인정보처리방침</h1>

      <p style={{ marginBottom: "20px" }}>
        <strong>주식회사 앤츠네스트</strong>(이하 "회사")는 「개인정보 보호법」에 따라 이용자의 개인정보를 보호하고
        이와 관련한 고충을 신속하고 원활하게 처리할 수 있도록 다음과 같이 개인정보처리방침을 수립·공개합니다.
      </p>

      <h2>1. 개인정보의 처리 목적</h2>
      <p>회사는 다음의 목적을 위하여 개인정보를 처리합니다.</p>
      <ul>
        <li>회원 가입 및 관리: 회원제 서비스 이용에 따른 본인확인, 서비스 부정이용 방지</li>
        <li>서비스 제공: AR 퀴즈 게임 서비스 제공, 게임 진행 및 결과 저장</li>
        <li>고객 문의 응대: 민원인의 신원 확인, 문의사항 확인 및 처리결과 통보</li>
      </ul>

      <h2>2. 처리하는 개인정보의 항목</h2>
      <ul>
        <li><strong>필수항목:</strong> 이메일 주소, 비밀번호, 닉네임</li>
        <li><strong>자동수집항목:</strong> IP 주소, 접속 로그, 서비스 이용 기록</li>
        <li><strong>기기정보:</strong> 기기 식별자, 운영체제 정보</li>
      </ul>

      <h2>3. 개인정보의 보유 및 이용 기간</h2>
      <p>
        회사는 법령에 따른 개인정보 보유·이용기간 또는 정보주체로부터 개인정보를 수집 시에 동의받은
        개인정보 보유·이용기간 내에서 개인정보를 처리·보유합니다.
      </p>
      <ul>
        <li>회원 정보: 회원 탈퇴 시까지</li>
        <li>게임 기록: 서비스 제공 기간 동안</li>
      </ul>

      <h2>4. 카메라 권한 사용</h2>
      <p>
        본 앱은 AR(증강현실) 기능 제공을 위해 카메라 권한을 사용합니다.
        카메라로 촬영된 영상은 AR 오브젝트 인식에만 사용되며, 별도로 저장되거나 서버로 전송되지 않습니다.
      </p>

      <h2>5. 개인정보의 제3자 제공</h2>
      <p>
        회사는 이용자의 개인정보를 원칙적으로 외부에 제공하지 않습니다.
        다만, 이용자가 사전에 동의한 경우 또는 법령의 규정에 의한 경우는 예외로 합니다.
      </p>

      <h2>6. 개인정보의 파기</h2>
      <p>
        회사는 개인정보 보유기간의 경과, 처리목적 달성 등 개인정보가 불필요하게 되었을 때에는
        지체없이 해당 개인정보를 파기합니다.
      </p>

      <h2>7. 정보주체의 권리·의무</h2>
      <p>이용자는 회사에 대해 언제든지 다음 각 호의 개인정보 보호 관련 권리를 행사할 수 있습니다.</p>
      <ul>
        <li>개인정보 열람 요구</li>
        <li>오류 등이 있을 경우 정정 요구</li>
        <li>삭제 요구</li>
        <li>처리정지 요구</li>
      </ul>

      <h2>8. 개인정보 보호책임자</h2>
      <p>
        회사는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한
        정보주체의 불만처리 및 피해구제 등을 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다.
      </p>
      <ul>
        <li><strong>담당자:</strong> 현용수</li>
        <li><strong>이메일:</strong> support@antsnest.co.kr</li>
      </ul>

      <h2>9. 개인정보처리방침 변경</h2>
      <p>이 개인정보처리방침은 2024년 1월 1일부터 적용됩니다.</p>

      <p style={{
        marginTop: "60px",
        textAlign: "center",
        color: "#666",
        borderTop: "1px solid #eee",
        paddingTop: "20px"
      }}>
        <strong>주식회사 앤츠네스트</strong><br />
        경기도 용인시
      </p>
    </div>
  );
}

export default PolicyPage;
